export const SUPPORT_EMAIL = 'support@liujunxian.top';